/**
 * @generated
 * This file was automatically generated and should not be manually edited.
 *
 * Auto-generated enum for: async_requests.status
 *
 * To regenerate: npm run db:codegen
 * Any manual changes will be overwritten on next generation.
 */

/* eslint-disable */
// @ts-nocheck

/**
 * AsyncRequestStatus enum representing allowed values for async_requests.status
 */
export enum AsyncRequestStatus {
  /** SUBMITTED */
  SUBMITTED = 'SUBMITTED',
  /** IN PROGRESS */
  IN_PROGRESS = 'IN_PROGRESS',
  /** COMPLETED */
  COMPLETED = 'COMPLETED',
  /** FAILED */
  FAILED = 'FAILED',
}
